/*
These functions make sure WordPress
and Foundation play nice together.
*/

jQuery(document).ready(function($) {
	
	// Remove empty P tags created by WP inside of Accordion and Orbit
	$('.accordion p:empty, .orbit p:empty').remove();

	// Adds Flex Video to YouTube and Vimeo Embeds
	$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
		if ( $(this).innerWidth() / $(this).innerHeight() > 1.5 ) {
			$(this).wrap("<div class='widescreen responsive-embed'/>");
		} else {
			$(this).wrap("<div class='responsive-embed'/>");
		}
	});

	// add class to header.header on scroll
	//color variables
	var scrollColor = '#ffffff';
	var scrollColorHover = '#803F26'; // brown
	var originalColor = '#99B2AD'; // light green
	var originalBlue = '#4E5E74'; //  blue

	$(window).scroll(function() {
		//home page
		if ($(this).scrollTop() > 0) {

			$('.home header.header').addClass('scrolled');
			$('header.header').addClass('scrolled');

		} else {
			
			$('header.header').removeClass('scrolled');
			$('.home header.header').removeClass('scrolled');
			
		}
	});
	//ADA Fix
	jQuery("a.logo").attr(
		"aria-label",
		"Home Link"
	  );
	// strip out <br> from footer links and add a space instead
	$('footer a').each(function() {
		$(this).html($(this).html().replace(/<br\s*\/?>/g,' '));
	});

	// mobile menu - strip out <br> from menu links and add a space instead
	if ($(window).width() <= 768) { // 768px is a common breakpoint for mobile devices
		$('.menu li a').each(function() {
			$(this).html($(this).html().replace(/<br\s*\/?>/g,' '));
		});
	}

	// If URL is === /sitemap add class to body
	if (window.location.pathname === '/sitemap') {
		$('body').addClass('sitemap');
		$('.site-content').before('<div class="spacer"></div>');
		$('.site-content').prepend('<h1>Sitemap</h1>');
	
	}
	
/* commented out mac specific styles for mac, not needed anymore but leaving here for reference
	$(document).ready(function() {
		// Function to detect Mac OS
		function isMac() {
			return navigator.platform.toUpperCase().indexOf('MAC') >= 0;
		}

		if (isMac()) {
			// Create a <style> element
			var style = $('<style type="text/css"></style>');
			var css = `
			.pagination .current {
				padding: 21px 14px 10px 14px;
				background: #4d5f74;
				color: #fefefe;
				cursor: default;
			}
			.blog .blue-row ul li a, .category .blue-row ul li a {
				background-color: #a8bcb8;
				color: #000;
				padding: 22px 10px 10px 10px!important;
				border-radius: 5px;
			}
			.blog .btn {
				padding: 20px 20px 10px 20px!important;
			}
			.button{
				// padding: 1.6em 2em 1em 2em;
				padding: 0.9rem 2rem 0.1rem !important;
			}
			`;
			// Append the CSS rules to the <style> element
			style.text(css);
			// Append the <style> element to the document's <head>
			$('head').append(style);
		}
	});

*/
		

}); 


